import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMIB.module.css"
import Utils from "../../../../../../../utils/Utils";
import Select from "../../../../../../../components/select/Select";
import Input from "../../../../../../../components/textbox/Input";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import CheckBox from "../../../../../../../components/checkbox/CheckBox";
import OggettiUtili from "../../../../../../../utils/OggettiUtili";
import malattiaBattericaMIB from "./MalattiaBattericaMIB";


class SqueleFocolaioMIB extends React.Component {

    state = {
        sequeleFocolaio: {
            sequele: {
                checkboxSequele1: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele1 ? this.props.statePadre.sequele.checkboxSequele1 : false,
                checkboxSequele2: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele2 ? this.props.statePadre.sequele.checkboxSequele2 : false,
                checkboxSequele3: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele3 ? this.props.statePadre.sequele.checkboxSequele3 : false,
                checkboxSequele4: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele4 ? this.props.statePadre.sequele.checkboxSequele4 : false,
                checkboxSequele5: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele5 ? this.props.statePadre.sequele.checkboxSequele5 : false,
                checkboxSequele6: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele6 ? this.props.statePadre.sequele.checkboxSequele6 : false,
                checkboxSequele7: this.props.statePadre && this.props.statePadre.sequele && this.props.statePadre.sequele.checkboxSequele7 ? this.props.statePadre.sequele.checkboxSequele7 : false

            },
            altro: this.props.statePadre && this.props.statePadre.altro ? this.props.statePadre.altro : "",
            contattoMalattia: this.props.statePadre && this.props.statePadre.contattoMalattia ? this.props.statePadre.contattoMalattia : "",
            contagio: this.props.statePadre && this.props.statePadre.contagio ? this.props.statePadre.contagio : "",
            contagioTesto: this.props.statePadre && this.props.statePadre.contagioTesto ? this.props.statePadre.contagioTesto : "",
            focolaio: this.props.statePadre && this.props.statePadre.focolaio ? this.props.statePadre.focolaio : "",
            focolaioTesto: this.props.statePadre && this.props.statePadre.focolaioTesto ? this.props.statePadre.focolaioTesto : "",
            comunita: this.props.statePadre && this.props.statePadre.comunita ? this.props.statePadre.comunita : "",
            comunitaAltro: this.props.statePadre && this.props.statePadre.comunitaAltro ? this.props.statePadre.comunitaAltro : "",
            corretto: []
        },
        malattiaBatterica: ""
    }

    constructor(props) {
        super(props)

        this.riceviValoreCheckbox = this.riceviValoreCheckbox.bind(this);
        this.riceviValore = this.riceviValore.bind(this);
        this.riceviValoreRadioButton = this.riceviValoreRadioButton.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this);
        this.controlloDati = this.controlloDati.bind(this);


    }

    componentDidMount() {
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setSequeleFocolaioMIB(this.state.sequeleFocolaio, oggetto)

        if(Utils.isEmpty(this.props.statePadre)) {
            if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB) {
                let sequeleFocolaio = this.state.sequeleFocolaio
                let sequeleFocolaioProps = this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB

                for (let i = 1; i < 22; i++) {
                    sequeleFocolaio.sequele["checkboxSequele" + i] = sequeleFocolaioProps.sequele["checkboxSequele" + i] ? sequeleFocolaioProps.sequele["checkboxSequele" + i] : this.state.sequeleFocolaio.sequele["checkboxSequele" + i]
                }

                sequeleFocolaio.altro = sequeleFocolaioProps.altro ? sequeleFocolaioProps.altro : this.state.sequeleFocolaio.altro
                sequeleFocolaio.contattoMalattia = sequeleFocolaioProps.contattoMalattia ? sequeleFocolaioProps.contattoMalattia : this.state.sequeleFocolaio.contattoMalattia
                sequeleFocolaio.contagio = sequeleFocolaioProps.contagio ? sequeleFocolaioProps.contagio : this.state.sequeleFocolaio.contagio
                sequeleFocolaio.contagioTesto = sequeleFocolaioProps.contagioTesto ? sequeleFocolaioProps.contagioTesto : this.state.sequeleFocolaio.contagioTesto
                sequeleFocolaio.focolaio = sequeleFocolaioProps.focolaio ? sequeleFocolaioProps.focolaio : this.state.sequeleFocolaio.focolaio
                sequeleFocolaio.focolaioTesto = sequeleFocolaioProps.focolaioTesto ? sequeleFocolaioProps.focolaioTesto : this.state.sequeleFocolaio.focolaioTesto
                sequeleFocolaio.comunita = sequeleFocolaioProps.comunita ? sequeleFocolaioProps.comunita : this.state.sequeleFocolaio.comunita
                sequeleFocolaio.comunitaAltro = sequeleFocolaioProps.comunitaAltro ? sequeleFocolaioProps.comunitaAltro : this.state.sequeleFocolaio.comunitaAltro

                this.setState({sequeleFocolaio: sequeleFocolaio});

            }
        }

        if (this.props.malattiaBatterica){
            this.setState({malattiaBatterica:this.props.malattiaBatterica})
        }


        this.controlloDati()
        oggetto = this.createOggettoBE()
        this.props.setSequeleFocolaioMIB(this.state.sequeleFocolaio, oggetto)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.malattiaBatterica !== this.props.malattiaBatterica) {
            this.setState({malattiaBatterica: this.props.malattiaBatterica})
            this.controlloDati()
            let oggetto = this.createOggettoBE()
            this.props.setSequeleFocolaioMIB(this.state.sequeleFocolaio, oggetto)
        }
    }

    createOggettoBE() {
        let sequeleFocolaio = JSON.parse(JSON.stringify(this.state.sequeleFocolaio))
        let sequeleFocolaioBe = Utils.removeEmptyValueFromObject(sequeleFocolaio)
        return Utils.removeFieldFromObject(sequeleFocolaioBe, "corretto")

    }

    controlloDati() {
        let sequeleFocolaio = this.state.sequeleFocolaio
        sequeleFocolaio.corretto = [];

        if (this.state.sequeleFocolaio.sequele.checkboxSequele7 && !this.state.sequeleFocolaio.altro) sequeleFocolaio.corretto[0] = "Campo \"Altra, specificare\" mancante";
        if (this.state.sequeleFocolaio.contagio === "2" && !this.state.sequeleFocolaio.contagioTesto) sequeleFocolaio.corretto[1] = "Campo \"Probabile contagio fuori dall'area di domicilio abituale? - Indicare dove\" mancante";
        if (this.state.sequeleFocolaio.focolaio === "2" && !this.state.sequeleFocolaio.focolaioTesto) sequeleFocolaio.corretto[2] = "Campo \"Il caso fa parte di un focolaio epidemico conosciuto? - Indicare quando\" mancante";
        if (this.state.sequeleFocolaio.comunita === "6" && !this.state.sequeleFocolaio.comunitaAltro) sequeleFocolaio.corretto[3] = "Campo \"Altra comunità\" mancante";


        if (this.props.malattiaBatterica && this.props.malattiaBatterica !== "malattiaBatterica4") {
            let contaControlla = 0;
            for (let i = 1; i < 8; i++) {
                if (!this.state.sequeleFocolaio.sequele["checkboxSequele" + i]) {
                    contaControlla++;
                }
            }
            if (contaControlla === 7) {
                sequeleFocolaio.corretto[4] = "Campo \"Sequele a 30 giorni dalla data di segnalazione ( solo se malattia batterica invasiva da S. pneumoniae, N. meningitidis, H. influenzae )\" mancante";
            }

            if (this.props.malattiaBatterica === "malattiaBatterica1" || this.props.malattiaBatterica === "malattiaBatterica3") {
                if(!sequeleFocolaio.contattoMalattia) sequeleFocolaio.corretto[5] = "Campo \"è stato a contatto con un altro caso della stessa malattia?\" mancante";
                if(!sequeleFocolaio.contagio) sequeleFocolaio.corretto[6] = "Campo \"Probabile contagio fuori dall'area di domicilio abituale?\" mancante";
                if(!sequeleFocolaio.focolaio) sequeleFocolaio.corretto[7] = "Campo \"Il caso fa parte di un focolaio epidemico conosciuto?\" mancante";
                if(!sequeleFocolaio.comunita) sequeleFocolaio.corretto[8] = "Campo \"Comunità frequentate\" mancante";
            }
        }

        this.setState({sequeleFocolaio: sequeleFocolaio})

    }

    riceviValore(field, event) {
        let sequeleFocolaio = this.state.sequeleFocolaio

        if (field.currentTarget) {
            sequeleFocolaio[field.currentTarget.id] = field.currentTarget.value
            sequeleFocolaio["comunitaAltro"] = sequeleFocolaio[field.currentTarget.id] !== "6" ? "" : this.state.sequeleFocolaio.comunitaAltro
        } else {
            sequeleFocolaio[field] = event.target.value
        }
        this.setState({sequeleFocolaio: sequeleFocolaio})
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setSequeleFocolaioMIB(this.state.sequeleFocolaio, oggetto)
    }

    riceviValoreCheckbox(id) {
        let sequeleFocolaio = this.state.sequeleFocolaio
        if (sequeleFocolaio.sequele[id] === true) {
            sequeleFocolaio.sequele[id] = false
        } else {
            sequeleFocolaio.sequele[id] = true
        }

        if (id === "checkboxSequele7" && sequeleFocolaio.sequele[id] === false) {
            sequeleFocolaio["altro"] = "";
        }

        this.setState({sequeleFocolaio: sequeleFocolaio})
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setSequeleFocolaioMIB(this.state.sequeleFocolaio, oggetto)
    }

    riceviValoreRadioButton(event, field) {
        let sequeleFocolaio = this.state.sequeleFocolaio
        sequeleFocolaio[field] = event

        if (field === "contagio" && sequeleFocolaio[field] !== 2) sequeleFocolaio.contagioTesto = "";
        if (field === "focolaio" && sequeleFocolaio[field] !== 2) sequeleFocolaio.focolaioTesto = "";


        this.setState({sequeleFocolaio: sequeleFocolaio})
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setSequeleFocolaioMIB(this.state.sequeleFocolaio, oggetto)
    }

    render() {

        const {t} = this.props

        const sezione1 = (

            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.Sequele.titolo")}
                        {this.state.malattiaBatterica !== "" && this.state.malattiaBatterica !== "malattiaBatterica4" ?
                            <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                    </h6>
                    <hr className={stylesWelcome.hr}/>
                </div>

                <div className={"container"}>
                    <div className="row">
                        <div className="col-lg-4">
                            <CheckBox id={"checkboxSequele1"}
                                      isRadio={false}
                                      checked={this.state.sequeleFocolaio.sequele["checkboxSequele1"]}
                                      fontColor={"black"}
                                      text={t("SchedaFlussoSpeciale.MIB.Sequele.1")}
                                      onChange={() => this.riceviValoreCheckbox("checkboxSequele1")}
                                      defaultChecked={
                                          this.props.segnalazioneCopia.schedaSpeciale &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele1"] ? true : false}

                            >
                            </CheckBox>
                            <div style={{marginTop: "-1rem"}}/>
                            <CheckBox id={"checkboxSequele2"}
                                      isRadio={false}
                                      checked={this.state.sequeleFocolaio.sequele["checkboxSequele2"]}
                                      fontColor={"black"}
                                      text={t("SchedaFlussoSpeciale.MIB.Sequele.2")}
                                      onChange={() => this.riceviValoreCheckbox("checkboxSequele2")}
                                      defaultChecked={
                                          this.props.segnalazioneCopia.schedaSpeciale &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele2"] ? true : false}
                            >
                            </CheckBox>
                            <div style={{marginTop: "-1rem"}}/>
                            <CheckBox id={"checkboxSequele3"}
                                      isRadio={false}
                                      checked={this.state.sequeleFocolaio.sequele["checkboxSequele3"]}
                                      fontColor={"black"}
                                      text={t("SchedaFlussoSpeciale.MIB.Sequele.3")}
                                      onChange={() => this.riceviValoreCheckbox("checkboxSequele3")}
                                      defaultChecked={
                                          this.props.segnalazioneCopia.schedaSpeciale &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele3"] ? true : false}
                            >
                            </CheckBox>
                            <div style={{marginTop: "-1rem"}}></div>
                            <CheckBox id={"checkboxSequele4"}
                                      isRadio={false}
                                      checked={this.state.sequeleFocolaio.sequele["checkboxSequele4"]}
                                      fontColor={"black"}
                                      text={t("SchedaFlussoSpeciale.MIB.Sequele.4")}
                                      onChange={() => this.riceviValoreCheckbox("checkboxSequele4")}
                                      defaultChecked={
                                          this.props.segnalazioneCopia.schedaSpeciale &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele4"] ? true : false}
                            >
                            </CheckBox>
                            <div style={{marginTop: "-1rem"}}/>
                            <CheckBox id={"checkboxSequele5"}
                                      isRadio={false}
                                      checked={this.state.sequeleFocolaio.sequele["checkboxSequele5"]}
                                      fontColor={"black"}
                                      text={t("SchedaFlussoSpeciale.MIB.Sequele.5")}
                                      onChange={() => this.riceviValoreCheckbox("checkboxSequele5")}
                                      defaultChecked={
                                          this.props.segnalazioneCopia.schedaSpeciale &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                          this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele5"] ? true : false}
                            >
                            </CheckBox>
                            <div style={{marginTop: "-1rem"}}/>
                            <CheckBox id={"checkboxSequele6"}
                                      isRadio={false}
                                      checked={this.state.sequeleFocolaio.sequele["checkboxSequele6"]}
                                      fontColor={"black"}
                                      text={t("SchedaFlussoSpeciale.MIB.Sequele.6")}
                                      onChange={() => this.riceviValoreCheckbox("checkboxSequele6")}
                                      defaultChecked={
                                          !!(this.props.segnalazioneCopia.schedaSpeciale &&
                                              this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                              this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele6"])}
                            >
                            </CheckBox>
                            <div style={{marginTop: "-1rem"}}/>
                            <div className="row">
                                <div className={"col-lg-6"}>
                                    <CheckBox id={"checkboxSequele7"}
                                              isRadio={false}
                                              checked={this.state.sequeleFocolaio.sequele["checkboxSequele7"]}
                                              fontColor={"black"}
                                              text={t("SchedaFlussoSpeciale.MIB.Sequele.7")}
                                              onChange={() => this.riceviValoreCheckbox("checkboxSequele7")}
                                              defaultChecked={
                                                  this.props.segnalazioneCopia.schedaSpeciale &&
                                                  this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB &&
                                                  this.props.segnalazioneCopia.schedaSpeciale.sequeleFocolaioMIB.sequele["checkboxSequele7"] ? true : false}
                                    >
                                    </CheckBox>
                                </div>
                                <div className={"col-lg-6"}>
                                    <Input
                                        id={"altro"}
                                        style={{height: "2rem", marginTop: "10px"}}
                                        onChange={this.riceviValore}
                                        field={"altro"}
                                        value={this.state.sequeleFocolaio.altro}
                                        placeholder={t("SchedaFlussoSpeciale.MIB.Sequele.7")}
                                        disabled={!this.state.sequeleFocolaio.sequele["checkboxSequele7"]}
                                        required={this.state.sequeleFocolaio.sequele["checkboxSequele7"]}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div style={{paddingTop: "2rem"}}>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.MIB.Focolaio.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>

                <div className={"container"}>
                    <div className={"col-lg-7"} style={{fontWeight: "bold", marginTop: "1rem", marginLeft: "-9px"}}>
                        <p>{t("SchedaFlussoSpeciale.MIB.Focolaio.1")}</p>
                    </div>
                    <div className="row" style={{marginTop: "1rem"}}>

                        <div className={"col-lg-5"}>
                            <p style={{marginTop: "10px"}}>{t("SchedaFlussoSpeciale.MIB.Focolaio.2")}
                                {this.state.malattiaBatterica === "malattiaBatterica1" || this.state.malattiaBatterica === "malattiaBatterica3" ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}</p>
                        </div>

                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"contattoMalattia1"}
                                         name={"contattoMalattia"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.Focolaio.6")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("1", "contattoMalattia")}
                                         checked={this.state.sequeleFocolaio.contattoMalattia === "1"}
                            />
                        </div>
                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"contattoMalattia2"}
                                         name={"contattoMalattia"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.Focolaio.7")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("2", "contattoMalattia")}
                                         checked={this.state.sequeleFocolaio.contattoMalattia === "2"}
                            />
                        </div>
                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"contattoMalattia3"}
                                         name={"contattoMalattia"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.Focolaio.8")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("3", "contattoMalattia")}
                                         checked={this.state.sequeleFocolaio.contattoMalattia === "3"}
                            />
                        </div>
                    </div>


                    <div className="row">

                        <div className={"col-lg-5"}>
                            <p style={{marginTop: "10px"}}>{t("SchedaFlussoSpeciale.MIB.Focolaio.3")}
                                {this.state.malattiaBatterica === "malattiaBatterica1" || this.state.malattiaBatterica === "malattiaBatterica3" ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                            </p>
                        </div>

                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"contagio1"}
                                         name={"contagio"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.Focolaio.6")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("1", "contagio")}
                                         checked={this.state.sequeleFocolaio.contagio === "1"}
                            />
                        </div>
                        <div className="row" style={{marginRight: "1rem"}}>
                            <div className={"col-lg-3"}>
                                <RadioButton id={"contagio2"}
                                             name={"contagio"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.MIB.Focolaio.5")}
                                             value={"0"}
                                             onClick={() => this.riceviValoreRadioButton("2", "contagio")}
                                             checked={this.state.sequeleFocolaio.contagio === "2"}
                                />
                            </div>
                            <div className={"col-lg-6"}>
                                <Input
                                    id={"contagioTesto"}
                                    style={{height: "2rem", marginTop: "10px"}}
                                    onChange={this.riceviValore}
                                    field={"contagioTesto"}
                                    value={this.state.sequeleFocolaio.contagioTesto}
                                    placeholder={t("SchedaFlussoSpeciale.MIB.Focolaio.10")}
                                    disabled={this.state.sequeleFocolaio.contagio !== "2"}
                                    required={this.state.sequeleFocolaio.contagio == "2"}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className={"col-lg-5"}>
                            <p style={{marginTop: "10px"}}>{t("SchedaFlussoSpeciale.MIB.Focolaio.4")}
                                {this.state.malattiaBatterica === "malattiaBatterica1" || this.state.malattiaBatterica === "malattiaBatterica3" ?
                                    <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                            </p>
                        </div>

                        <div style={{marginRight: "1rem"}}>
                            <RadioButton id={"focolaio1"}
                                         name={"focolaio"}
                                         style={{color: "black", fontSize: "16px"}}
                                         label={t("SchedaFlussoSpeciale.MIB.Focolaio.6")}
                                         value={"0"}
                                         onClick={() => this.riceviValoreRadioButton("1", "focolaio")}
                                         checked={this.state.sequeleFocolaio.focolaio === "1"}
                            />
                        </div>
                        <div className="row">
                            <div className={"col-lg-3"}>
                                <RadioButton id={"focolaio2"}
                                             name={"focolaio"}
                                             style={{color: "black", fontSize: "16px"}}
                                             label={t("SchedaFlussoSpeciale.MIB.Focolaio.5")}
                                             value={"0"}
                                             onClick={() => this.riceviValoreRadioButton("2", "focolaio")}
                                             checked={this.state.sequeleFocolaio.focolaio === "2"}
                                />
                            </div>
                            <div className={"col-lg-6"}>
                                <Input
                                    id={"focolaioTesto"}
                                    style={{height: "2rem", marginTop: "10px"}}
                                    onChange={this.riceviValore}
                                    field={"focolaioTesto"}
                                    value={this.state.sequeleFocolaio.focolaioTesto}
                                    placeholder={t("SchedaFlussoSpeciale.MIB.Focolaio.11")}
                                    disabled={this.state.sequeleFocolaio.focolaio !== "2"}
                                    required={this.state.sequeleFocolaio.focolaio === "2"}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

        const sezione3 = (
            <div className={"container"}>

                <div className="row">

                    <div className="col-lg-3">
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.MIB.Focolaio.9")}
                            {this.state.malattiaBatterica === "malattiaBatterica1" || this.state.malattiaBatterica === "malattiaBatterica3" ?
                                <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                        </p>
                        <Select
                            field={"comunita"}
                            value={this.state.sequeleFocolaio.comunita}
                            onChange={this.riceviValore}
                            id={"comunita"}
                            functionMap={Utils.mapToArray(OggettiUtili.CollettivitaMIB).map((oggetto) => {
                                return (
                                    <option value={oggetto.codice}>{oggetto.descrizione}</option>)
                            })}
                        >
                        </Select>
                    </div>
                </div>
            </div>


        );

        const sezione4 = (

            <div className={"container"}>
                <div className="row">
                    <div className="col-lg-3">
                        <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                            {t("SchedaFlussoSpeciale.MIB.Focolaio.12")}
                            {this.state.sequeleFocolaio.comunita === "6" ?
                                <span className={stylesWelcome.mandatoryColor}>*</span> : <span/>}
                        </p>
                        <Input
                            id={"comunitaAltro"}
                            onChange={this.riceviValore}
                            field={"comunitaAltro"}
                            value={this.state.sequeleFocolaio.comunitaAltro}
                            placeholder={t("SchedaFlussoSpeciale.MIB.Focolaio.12")}
                            // required={this.state.sequeleFocolaio.comunita === "6"}
                        />
                    </div>
                </div>
            </div>

        )

        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
                {this.state.sequeleFocolaio.comunita === "6" ?
                    (<div> {sezione4}</div>) : (<div/>)
                }
            </div>

        )
    }

}

export default withTranslation('common')(SqueleFocolaioMIB)
